import {
  installCookieBanner as publicInstallCookieBanner,
  getCookieBannerSettings as publicGetCookieBannerSettings,
  updateCookieBannerSettings as publicUpdateCookieBannerSettings,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const installCookieBanner: MaybeContext<
  BuildRESTFunction<typeof publicInstallCookieBanner> &
    typeof publicInstallCookieBanner
> = /*#__PURE__*/ createRESTModule(publicInstallCookieBanner);
export const getCookieBannerSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetCookieBannerSettings> &
    typeof publicGetCookieBannerSettings
> = /*#__PURE__*/ createRESTModule(publicGetCookieBannerSettings);
export const updateCookieBannerSettings: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCookieBannerSettings> &
    typeof publicUpdateCookieBannerSettings
> = /*#__PURE__*/ createRESTModule(publicUpdateCookieBannerSettings);

export {
  PrivacyPolicyDetailsReferenceType,
  ButtonPosition,
  CornerRadius,
  Audience,
  PrivacyPolicyType,
  Theme,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';
export {
  CookieBannerSettings,
  SlugDetails,
  ExternalPageUrlDetails,
  SiteColor,
  DeclineAllConfig,
  RevisitSettingsConfig,
  CustomThemeConfig,
  PrivacyPolicyPageInfo,
  PrivacyPolicyPageInfoDetailsOneOf,
  GetCookieBannerPreviewSettingsRequest,
  GetCookieBannerPreviewSettingsResponse,
  SetCookieBannerPreviewSettingsRequest,
  SetCookieBannerPreviewSettingsResponse,
  DeleteCookieBannerPreviewSettingsRequest,
  DeleteCookieBannerPreviewSettingsResponse,
  GetChannelPermissionsRequest,
  Channel,
  Subscriber,
  GetChannelPermissionsResponse,
  InstallCookieBannerRequest,
  ConsentPolicy,
  InstallCookieBannerResponse,
  GetCookieBannerSettingsRequest,
  GetCookieBannerSettingsResponse,
  SetCookieBannerSettingsRequest,
  SetCookieBannerSettingsResponse,
  UpdateCookieBannerSettingsRequest,
  UpdateCookieBannerSettingsResponse,
  InstallCookieBannerOptions,
  GetCookieBannerSettingsOptions,
  UpdateCookieBannerSettingsOptions,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';
export {
  PrivacyPolicyDetailsReferenceTypeWithLiterals,
  ButtonPositionWithLiterals,
  CornerRadiusWithLiterals,
  AudienceWithLiterals,
  PrivacyPolicyTypeWithLiterals,
  ThemeWithLiterals,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';
